import { TPanoramaVm } from "..";

export const PanoramaVm: TPanoramaVm = {
  phase: {
    position: [-3051676.982466365, 4040969.0417857477, 3865328.774857175],
    orientation: {
      heading: 1.0234253875925443,
      pitch: -0.6210454884469185,
      roll: 0.000013225861872356859,
    },
  },
  //   baseModelPath: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/3d-tiles-merged/2024/tileset.json`,
  baseModelPath: `${process.env.REACT_APP_DATA_BASE_URL}/models/Manual/K-HQ/tileset.json`,
  items: [
    {
      index: 1,
      // position: [127.052899, 37.5404523, 105.5],
      position: [127.062376, 37.5422839, 100.0],
      view: {
        // position: [127.0534805, 37.5395436, 140],
        position: [127.0655187, 37.5447434, 200],
        orientation: {
          heading: 230.0,
          pitch: -15.0,
          roll: 0.0,
        },
      },
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panoramas/20250321/250321_KP_C4_360panorama_1.JPG`,
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panoramas/20250321/250321_KP_C4_360panorama_thumbnail_1.jpg`,
    },
    {
      index: 2,
      // position: [127.0528619, 37.5403614, 105],
      position: [127.0628652, 37.542346, 50.0],
      view: {
        position: [127.0618053, 37.5422044, 60],
        orientation: {
          heading: 77.5,
          pitch: -15.0,
          roll: 0.0,
        },
      },
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panoramas/20250321/250321_KP_C4_360panorama_2.JPG`,
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panoramas/20250321/250321_KP_C4_360panorama_thumbnail_2.jpg`,
    },
    {
      index: 3,
      position: [127.0624495, 37.5424702, 50.0],
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panoramas/20250321/250321_KP_C4_360panorama_3.JPG`,
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panoramas/20250321/250321_KP_C4_360panorama_thumbnail_3.jpg`,
      view: {
        position: [127.0621704, 37.5417802, 60],
        orientation: {
          heading: 22.5,
          pitch: -12.5,
          roll: 0.0,
        },
      },
    },
    {
      index: 4,
      position: [127.062049, 37.5425918, 50.0],
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panoramas/20250321/250321_KP_C4_360panorama_4.JPG`,
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panoramas/20250321/250321_KP_C4_360panorama_thumbnail_4.jpg`,
      view: {
        position: [127.0627162, 37.541922, 60],
        orientation: {
          heading: -32.5,
          pitch: -12.5,
          roll: 0.0,
        },
      },
    },
    {
      index: 5,
      position: [127.061864, 37.5422091, 50.0],
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panoramas/20250321/250321_KP_C4_360panorama_5.JPG`,
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panoramas/20250321/250321_KP_C4_360panorama_thumbnail_5.jpg`,
      view: {
        // 5
        position: [127.0629265, 37.5423544, 60],
        orientation: {
          heading: 260.0,
          pitch: -12.5,
          roll: 0.0,
        },
      },
    },
    {
      index: 6,
      position: [127.0622822, 37.5420849, 50.0],
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panoramas/20250321/250321_KP_C4_360panorama_6.JPG`,
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panoramas/20250321/250321_KP_C4_360panorama_thumbnail_6.jpg`,
      view: {
        position: [127.0625792, 37.5427845, 60],
        orientation: {
          heading: 200.0,
          pitch: -12.5,
          roll: 0.0,
        },
      },
    },
    {
      index: 7,
      position: [127.0626802, 37.5419632, 50.0],
      url: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panoramas/20250321/250321_KP_C4_360panorama_7.JPG`,
      img: `${process.env.REACT_APP_DATA_BASE_URL || ""}/models/panoramas/20250321/250321_KP_C4_360panorama_thumbnail_7.jpg`,
      view: {
        position: [127.062005, 37.5426309, 60],
        orientation: {
          heading: 140.0,
          pitch: -12.5,
          roll: 0.0,
        },
      },
    },
  ],
};

export default { PanoramaVm };
